/*
 * ╔══════════════════════════════════════════════════════════════════════════╗
 * ║ ALIGHT LOGOSI — RASM EMAS, LOGONING O'ZI                                ║
 * ║                                                                          ║
 * ║ Yo'llar `alight_logo (6).pdf` faylining ICHIDAN olingan: PDF vektor      ║
 * ║ edi (ichida surat yo'q, faqat kontur + CMYK), shuning uchun konturlar    ║
 * ║ koordinatasi bilan ko'chirildi va 0..100 ramkasiga normallashtirildi.    ║
 * ║                                                                          ║
 * ║ PNG qo'yish OSON yo'l edi va u uch joyda yiqilardi: yon menyu 28 px      ║
 * ║ da logoni loyqa ko'rsatardi, Retina ekranda ikki barobar fayl kerak      ║
 * ║ bo'lardi, chop etishda esa logo rastr bo'lib dog' bo'lib chiqardi.       ║
 * ║ SVG uchalasini ham hal qiladi va og'irligi ~1 kB.                        ║
 * ║                                                                          ║
 * ║ ⚠️ RANG BU YERDA QOTIRILMAYDI — `currentColor` va brend tokeni.          ║
 * ║ Logo qorong'i menyuda ham, oq kirish ekranida ham, qog'ozda ham turadi.  ║
 * ║ Har biriga alohida fayl qilish o'rniga rang tashqaridan beriladi.        ║
 * ╚══════════════════════════════════════════════════════════════════════════╝
 */

/** Faqat belgi — chaqmoq. Menyu yig'ilganda va favicon o'rnida ishlatiladi. */
export function AlightMark({ className = 'h-7 w-7' }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 93.47 100"
      className={className}
      role="img"
      aria-label="Alight"
      fill="none"
    >
      {/* Chaqmoqning ikki qanoti — brend yashili */}
      <path
        d="M43.71 0 L32.9 21.79 L61.82 80.34 L83.7 80.34 Z"
        fill="var(--color-brand-vivid)"
      />
      <path
        d="M25.98 80.28 L36.79 57.78 L25.98 36.53 L4.19 80.34 C0 95.98 9.24 100 22.77 100 L58.3 100 L48.3 80.28 Z"
        fill="var(--color-brand-vivid)"
      />
      {/*
       * Ikki limon chiziq — LED nuri. Ular ATAYLAB belgidan kichik va
       * pastda: logoda ular urg'u, ilovada esa limon rang boshqa hech
       * qayerda matn bo'lib ishlatilmaydi (oq fonda kontrasti 1.09).
       */}
      <path
        d="M86.07 85.12 L64.17 85.12 L64.74 87.03 L66.2 90.17 L88.58 90.17 L86.25 85.49 Z"
        fill="var(--color-accent)"
      />
      <path
        d="M90.96 94.95 L69.17 94.95 L70.79 100 L93.47 100 Z"
        fill="var(--color-accent)"
      />
    </svg>
  );
}
